import BaseCache from '../base/cache';
import { RequestOption } from '../base/define';
import config from './config';
import { SmsRequest } from './define';

export default class CommonCache extends BaseCache {
  constructor() {
    super(config);
  }

  getSystemTime(option: RequestOption<undefined, undefined>) {
    return this.doSendRequest('get-system-time', option) as Promise<number>;
  }

  // 更新追踪链
  updateTraceName(option: RequestOption<undefined, {_trace_name: string}>) {
    return this.doSendRequest('update-trace-name', option) as Promise<string>;
  }

  /**
   * 通用记录日志接口
   * @param option
   * @returns
   */
  reportLog(option: RequestOption<any, undefined>) {
    return this.doSendRequest('report-log', option) as Promise<boolean>;
  }

  /**
   * 发送验证码
   * @param option
   * @returns
   */
  sendSms(option: RequestOption<SmsRequest, undefined>) {
    return this.doSendRequest('send-sms', option) as Promise<boolean>;
  }

  /**
   * 校验验证码是否正确
   * @param option
   * @returns
   */
  verifySms(option: RequestOption<{mobile: string; verifyCode: string}, undefined>) {
    return this.doSendRequest('verify-sms', option) as Promise<boolean>;
  }
}
